import { Fragment } from 'react';
import { coreExtensionData } from '@backstage/frontend-plugin-api';
import nativeCatalogPlugin, { CatalogIndexPage } from '@backstage/plugin-catalog/alpha';
import {
  EntityLifecyclePicker,
  EntityNamespacePicker,
  EntityProcessingStatusPicker,
} from '@backstage/plugin-catalog-react';
import { catalogColumns } from '../../components/catalog/catalogColumns';
import { variaEntityCards, variaEntityContents } from './variaEntityExtensions';

// Our entity tabs show these instead (Dependencies, Architecture), or Varia never showed them.
// Move to `app.extensions` config when the new-frontend-system flag is removed; until then these IDs don't exist with the flag off.
const replacedNativeExtensionIds = [
  'entity-card:catalog/labels',
  'entity-card:catalog/depends-on-components',
  'entity-card:catalog/depends-on-resources',
  'entity-card:catalog/has-components',
  'entity-card:catalog/has-resources',
  'entity-card:catalog/has-subcomponents',
  'entity-card:catalog/has-subdomains',
] as const;

const catalogIndexPage = nativeCatalogPlugin.getExtension('page:catalog').override({
  factory: (originalFactory, { inputs }) =>
    originalFactory({
      params: {
        loader: async () => (
          <CatalogIndexPage
            columns={catalogColumns}
            filters={
              <>
                {inputs.filters.map(filter => (
                  <Fragment key={filter.node.spec.id}>
                    {filter.get(coreExtensionData.reactElement)}
                  </Fragment>
                ))}
              </>
            }
          />
        ),
      },
    }),
});

// Hidden, but still applied from the URL query.
const hiddenCatalogFilters = [
  ['catalog-filter:catalog/lifecycle', EntityLifecyclePicker],
  ['catalog-filter:catalog/processing-status', EntityProcessingStatusPicker],
  ['catalog-filter:catalog/namespace', EntityNamespacePicker],
] as const;

// Templates show the About card on their Details tab instead.
const aboutCard = nativeCatalogPlugin.getExtension('entity-card:catalog/about').override({
  factory: (originalFactory, { config }) =>
    originalFactory({
      config: {
        ...config,
        filter: config.filter ?? { $not: { kind: { $in: ['user', 'group', 'template'] } } },
      },
    }),
});

export const nfsCatalogPlugin = nativeCatalogPlugin.withOverrides({
  extensions: [
    catalogIndexPage,
    aboutCard,
    ...hiddenCatalogFilters.map(([id, Picker]) =>
      nativeCatalogPlugin.getExtension(id).override({
        params: {
          loader: async () => (
            <div hidden>
              <Picker />
            </div>
          ),
        },
      }),
    ),
    ...replacedNativeExtensionIds.map(id =>
      nativeCatalogPlugin.getExtension(id).override({ disabled: true }),
    ),
    ...variaEntityCards,
    ...variaEntityContents,
  ],
});
